import { cardsData } from '@/mocks/homeData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Manga%20reading%20guide%20illustration%20with%20smartphone%20showing%20comic%20scroll%20interface%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20minimal%20design%2C%20soft%20studio%20lighting%2C%20editorial%20style&width=640&height=360&seq=card-img-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Collection%20of%20Korean%20webtoon%20style%20comic%20covers%20arranged%20artistically%20in%20warm%20lighting%2C%20editorial%20recommendation%20concept%2C%20vibrant%20orange%20and%20red%20accents%2C%20professional%20layout&width=640&height=360&seq=card-img-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20in%20traditional%20ink%20painting%20style%20with%20martial%20arts%20theme%2C%20warm%20golden%20and%20amber%20tones%2C%20elegant%20composition%2C%20cultural%20artistic%20aesthetic&width=640&height=360&seq=card-img-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20Japanese%20manga%20books%20on%20wooden%20shelf%20with%20warm%20vintage%20lighting%2C%20retro%20atmosphere%2C%20soft%20orange%20and%20amber%20glow%2C%20sentimental%20editorial%20photography&width=640&height=360&seq=card-img-4&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Beginner%20friendly%20manga%20reading%20setup%20with%20tablet%20and%20cozy%20atmosphere%2C%20warm%20ambient%20lighting%2C%20modern%20lifestyle%20photography%2C%20clean%20aesthetic%2C%20soft%20colors&width=640&height=360&seq=card-img-5&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Summer%20reading%20list%20concept%20with%20manga%20books%20and%20sunlight%2C%20warm%20golden%20hour%20lighting%2C%20cozy%20outdoor%20setting%2C%20editorial%20lifestyle%20photography%2C%20fresh%20seasonal%20aesthetic&width=640&height=360&seq=card-img-6&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Manga%20to%20film%20adaptation%20concept%20showing%20comic%20panels%20transforming%20into%20cinematic%20scenes%2C%20dramatic%20warm%20lighting%2C%20creative%20visual%20metaphor%2C%20artistic%20composition&width=640&height=360&seq=card-img-7&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4 whitespace-nowrap">
            精选图文
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画资讯与阅读指南
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">精选漫画行业资讯、阅读指南和追更推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={cardImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-secondary-500 text-white rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[10px] text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="text-xs font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer">
                    阅读全文 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}